//
// StackLayout.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./LayoutElement";
import "@sas-dvr/ltjs-commons/styles/VerticalPosition";
import "@sas-dvr/ltjs-commons/styles/HorizontalPosition";
import "@sas-dvr/ltjs-commons/styles/ButtonType";

var StackLayout = createModule("BIRD::StackLayout", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::LayoutElement"], EventDispatcher, [
    ,
    {
        verticalPosition: 4,
        buttonType: 4,
        horizonalPosition: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default StackLayout;
